import { Addons, ConnectorIds } from '@/common/constants';
import { baseApi } from '@/store/baseApi';

const baseUrl = '/trial';

export const trialApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    startProductTrial: build.mutation<string, ConnectorIds>({
      query: (payload) => ({ url: baseUrl, method: 'POST', body: { productId: payload } }),
    }),
    startAddonTrial: build.mutation<string, Addons>({
      query: (payload) => ({ url: baseUrl, method: 'POST', body: { addonId: payload } }),
    }),
  }),
});

export const { useStartProductTrialMutation, useStartAddonTrialMutation } = trialApi;
